var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#FDAB29"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 21,
    width: 4,
    height: 26,
    rx: 1,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 47,
    width: 4,
    height: 40,
    rx: 1,
    transform: "rotate(-90 10 47)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 21,
    width: 4,
    height: 26,
    rx: 1,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 23.7754,
    width: 4,
    height: 18,
    rx: 2,
    transform: "rotate(-35 19 23.7754)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 18,
    rx: 2,
    transform: "matrix(-0.819152 -0.573576 -0.573576 0.819152 40.5 23.7754)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 22,
    rx: 2,
    transform: "matrix(1 0 0 -1 27.8008 33)",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.18a2cd2c583a17f8c32f47fa80bfcea8.svg";
export { ForwardRef as ReactComponent };